import React, { useEffect, useState } from 'react'
import { RootState } from 'app/rootReducer'
import { useDispatch, useSelector } from 'react-redux'
import Navbar from '../../../organisms/Navbar'
import SubscriptionManager from '../SubscriptionManager'
import { useHistory } from 'react-router'
import { logOut } from 'share/utils/authenticationUtils'
import { useMutation } from '@apollo/client'
import { SignOffResponse, SIGN_OFF } from 'share/mutations/authentication'

const GlobalNavbar = (): JSX.Element => {
  const authentication = useSelector((state: RootState) => state.authentication)
  const history = useHistory()
  const dispatch = useDispatch()
  const [showMenu, setShowMenu] = useState(false)
  const [signOff] = useMutation<SignOffResponse>(SIGN_OFF)

  useEffect(() => {
    let isCanceled = false

    const checkAccountCreation = async () => {
      if (history.location.pathname.startsWith('/account-creation/')) {
        if (authentication.isAuthenticated) {
          await signOff()
        }
        await logOut(dispatch)
      }
      if (!isCanceled) setShowMenu(true)
    }
    checkAccountCreation()

    return () => {
      isCanceled = true
    }
  }, [])

  function loadSubscriptionManager(): boolean {
    if (authentication) {
      if (authentication.account && authentication.isAuthenticated) {
        if (authentication.account.id > 0) {
          return true
        }
      }
    }
    return false
  }

  function getAccountId(): number {
    if (authentication) {
      if (authentication.account && authentication.isAuthenticated) {
        if (authentication.account.id > 0) {
          return authentication.account.id
        }
      }
    }
    return 0
  }

  return (
    <>
      {loadSubscriptionManager() && (
        <SubscriptionManager accountId={getAccountId()} />
      )}
      <Navbar
        isAuthenticated={authentication.isAuthenticated && showMenu}
        idToken={authentication.idToken}
        username={authentication.account?.givenName || undefined}
      />
    </>
  )
}

export default GlobalNavbar
